let linksColumn = [
    {
        title: 'Centro de Ayuda',
        links: [
            {
                title: 'Problemas con tu pedido',
                url: 'https://ayuda.jumbo.cl/ayuda/contactanos',
                target: '_blank'
            },
            {
                title: 'Información de pago',
                url: 'https://ayuda.jumbo.cl/ayuda/medios-pago/medios-pago',
                target: '_blank'
            },
            {
                title: 'Cómo modificar mis datos',
                url: 'https://ayuda.jumbo.cl/ayuda/modificar-datos/actualizar-datos',
                target: '_blank'
            },
            {
                title: 'Modos de entrega y cobertura',
                url: 'https://ayuda.jumbo.cl/ayuda/despacho-retiro/zonas-cobertura',
                target: '_blank'
            },
            {
                title: 'Locales Jumbo',
                url: 'https://ayuda.jumbo.cl/ayuda/locales-jumbo/locales-jumbo',
                target: '_blank'
            },
            {
                title: 'Cómo comprar en Jumbo.cl',
                url: 'https://ayuda.jumbo.cl/ayuda/comprar-jumbo/crear-cuenta',
                target: '_blank'
            },
            {
                title: 'Servicio al cliente',
                url: 'https://ayuda.jumbo.cl/ayuda/servicio-cliente/informacion-contacto',
                target: '_blank'
            },
        ]
    },
    {
        title: 'Jumbo',
        links: [
            {
                title: 'Compromisos Jumbo',
                url: '/compromisos-jumbo',
                target: '_self'
            },
            {
                title: 'Mundos Jumbo',
                url: 'https://www.mundosjumbo.cl/',
                target: '_blank'
            },
            {
                title: 'Locales Jumbo',
                url: '/locales',
                target: '_self'
            }, 
            {
                title: 'Productos Jumbo',
                url: '/jumbo',
                target: '_self'
            },
            {
                title: 'Jumbo Proveedores',
                url: '/institucional/proveedores',
                target: '_self'
            },
            {
                title: 'Concursos',
                url: '/institucional/concursos',
                target: '_self'
            },
        ]
    },
    {
        title: 'Cencosud',
        links: [
            {
                title: 'Paris',
                url: 'https://www.paris.cl/',
                target: '_blank'
            },
            {
                title: 'Easy',
                url: 'https://www.easy.cl/',
                target: '_blank'
            }, 
            {
                title: 'Santa Isabel',
                url: 'https://www.santaisabel.cl/',
                target: '_blank'
            },
            {
                title: 'Tarjeta Cencosud Scotiabank',
                url: 'https://www.tarjetacencosud.cl/TarjetaMasWEB/inicio.do?utm_source=jumbo_cl&utm_medium=Footer&utm_content=rfcl&utm_campaign=Marca',
                target: '_blank'
            },
            {
                title: 'Seguro Cencosud',
                url: 'https://www.seguroscencosud.cl/vseg-paris/index.jsp?utm_source=Jumbo&utm_medium=footer&utm_campaign=footer-Seguros_04-2013',
                target: '_blank'
            },
            {
                title: 'Puntos Cencosud',
                url: 'https://www.puntoscencosud.cl/portal/faces/consultar-puntos?utm_source=Banner_UDN&amp;utm_medium=Banner&amp;utm_campaign=Jumbo&amp;_afrLoop=945351832790671&amp;_afrWindowMode=0&amp;_afrWindowId=littleWindow#!%40%40%3Futm_medium%3DBanner%26_afrWindowId%3DlittleWindow%26utm_source%3DBanner_UDN%26utm_campaign%3DJumbo%26_afrLoop%3D945351832790671%26_afrWindowMode%3D0%26_adf.ctrl-state%3Dz9trlxowo_14',
                target: '_blank'
            },
            {
                title: 'Giftcard',
                url: 'https://www.giftcard.cl/',
                target: '_blank'
            },
            {
                title: 'Trabaja con Nosotros',
                url: 'https://cencosud.trabajando.com/',
                target: '_blank'
            },
            {
                title: 'Venta Empresa',
                url: 'https://www.ventaempresascencosud.cl',
                target: '_blank'
            }
        ],
    },
    
];

export default linksColumn;



